import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import HomePage from "../views/HomePage";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: () => import("../views/home"),
      meta: {
        title: "多普云科技"
      }
    },
    {
      path: "/information",
      component: () => import("../views/information"),
      children: [
        {
          path: "informationlist",
          name: "informationlist",
          component: () => import("../views/pages/Dynamic"),
          meta: {
            title: "资讯中心"
          }
        },
        // {
        //   path: 'industry',
        //   name: 'industry',
        //   component: () => import('../views/pages/IndustryDynamic'),
        //   meta: {
        //     title: '行业动态',
        //   },
        // },
        // {
        //   path: 'announcements',
        //   name: 'announcements',
        //   component: () => import('../views/pages/Announcements'),
        //   meta: {
        //     title: '通知公告',
        //   },
        // },
        {
          path: "dynamicdetails",
          name: "dynamicdetails",
          component: () => import("../views/pages/dynamicdetails")
        }
      ]
    },
    {
      path: "/solution",
      name: "solution",
      component: () => import("../views/solution"),
      meta: {
        title: "解决方案"
      }
    },
    {
      path: "/open",
      name: "open",
      component: () => import("../views/open"),
      meta: {
        title: "会员"
      }
    },
    {
      path: "/product",
      component: () => import("../views/product"),
      meta: {
        title: "产品中心"
      },
      children: [
        {
          path: "freetrial",
          component: () => import("../views/FreeTrial.vue"),
          meta: {
            title: "免费试用"
          }
        },
        {
          path: "pricing",
          component: () => import("../views/pricing"),
          meta: {
            title: "定价"
          }
        },
        {
          path: "authentication",
          component: () => import("../views/authentication"),
          meta: {
            title: "企业认证"
          }
        }
      ]
    },
    {
      path: "/recruitment",
      component: () => import("../views/recruitment"),
      meta: {
        title: "人才招聘"
      }
    },
    {
      path: "/download",
      component: () => import("../views/download"),
      children: [
        {
          path: "software",
          name: "software",
          component: () => import("../views/pages/software"),
          meta: {
            title: "软件下载"
          }
        },
        {
          path: "datalist",
          name: "datalist",
          component: () => import("../views/pages/DataList"),
          meta: {
            title: "数据"
          }
        },
        {
          path: "documents",
          name: "documents",
          component: () => import("../views/pages/documents"),
          meta: {
            title: "文档"
          }
        },
        {
          path: "other",
          name: "other",
          component: () => import("../views/pages/other"),
          meta: {
            title: "文档"
          }
        }
      ]
    },
    {
      path: "/aboutus",
      component: () => import("../views/aboutus"),
      meta: {
        title: "关于我们"
      }
    },
    {
      path: "/login",
      component: () => import("../views/login"),
      meta: {
        title: "登录"
      }
    },
    {
      path: "/wxlogin",
      name: "wxlogin",
      component: () => import("../views/pages/wxlogin"),
      meta: {
        title: "微信登录"
      }
    },
    {
      path: "/retrieve",
      component: () => import("../views/retrievepassword")
    },
    {
      path: "/homepage",
      component: () => import("../views/personalhomepage"),
      children: [
        {
          path: "order",
          component: () => import("../views/pages/order")
        },
        {
          path: "team",
          component: () => import("../views/pages/team")
        },
        {
          path: "account",
          component: () => import("../views/pages/account")
        },
        {
          path: "personaldata",
          component: () => import("../views/pages/PersonalData")
        },
        {
          path: "realname",
          component: () => import("../views/pages/real-name")
        }
      ]
    },
    {
      path: "/alipaypay",
      component: () => import("../views/AlipayPay"),
      meta: {
        title: "收银台"
      }
    },
    {
      path: "/paysuccesss",
      name: "paysuccesss",
      component: () => import("../views/Paysuccesss"),
      meta: {
        title: "支付成功"
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import("../views/pages/PrivacyProtection"),
      meta: {
        title: "隐私保护"
      }
    },
    {
      path: "/agreement",
      name: "agreement",
      component: () => import("../views/pages/UserAgreement"),
      meta: {
        title: "用户协议"
      }
    },
    {
      path: "/pdfViewer",
      name: "pdfViewer",
      component: () => import("../views/pages/pdfViewer.vue"),
      meta: {
        title: "武汉多普云科技有限公司"
      }
    }
  ]
});

router.afterEach((to, from) => {
  // console.log('后置路由守卫', to, from)
  document.title = to.meta.title || "多普云科技有限公司";
});

// personal homepage
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js